import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NewsSlider = () => {

  const izbNewsSlider31 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia-thumb.webp";

  const izbNewsSlider32 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-thumb.jpg"

  const izbNewsSlider33 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-csr-medical-equipment-thumb.jpg"
  const izbNewsSlider34 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/MoF_news.01AM.jpeg"
  const izbNewsSlider35 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_9651.jpg.jpeg"
  const izbNewsSlider36 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZBFRA2026.jpeg"

  const izbNewsSlider37 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/SUS_1328.jpg"
  const izbNewsSlider38 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0608.jpg"
  const izbNewsSlider39 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/SOLACE%20Annual%20General%20Conference.JPG.jpeg"
  const izbNewsSlider40 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0663.jpg"

  const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
  const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";


  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowLeft}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "50px",
          height: "50px",
          left: "-58px",
          zIndex: "99"
        }}
        onClick={onClick}
      />
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowRight}
        className={className}

        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="news-slider-main">
      <div className="container">
        <div className="row">
          <div className="container">
            <div className="heading pt-5">
              <h1 className="text-center">Latest News</h1>
              <p className="text-center pt-2">All News And Updates</p>
            </div>
            <div
              className="py-4 read-more-flot-btn"
            >
              <Link
                to="/LatestNews"
                className="text-white rounded px-3 pt-1 pb-2"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                View All <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/luapula-province-courtesy-call" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider40} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/luapula-province-courtesy-call" style={{ textTransform: "none" }}>
                    Indo Zambia Bank Pays Courtesy Call on Luapula Province Minister
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>April 21, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  Today, we paid a courtesy call on the Office of the Luapula Province Minister, Hon. Eng. Nason Musonda MP, where we engaged in productive discussions on supporting key developmental projects across the province...
                </p>
                <a href="/luapula-province-courtesy-call">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/solace-annual-general-conference" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider39} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/solace-annual-general-conference" style={{ textTransform: "none" }}>
                    Indo Zambia Bank Sponsors SOLACE Annual General Conference
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>April 20, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  Indo Zambia Bank is proud to have been a sponsor and to have participated in the Society of Local Authority Chief Executives and Senior Managers (SOLACE) Annual General Conference, held in Kitwe from 13 to 14th April 2026...
                </p>
                <a href="/solace-annual-general-conference">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet">
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/indo-zambia-bank-announces-2025-financial-performance-results" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider37} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/indo-zambia-bank-announces-2025-financial-performance-results" style={{ textTransform: "none" }}>
                    Indo Zambia Bank Announces Strong 2025 Financial Performance Results
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>April 09, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  Indo Zambia Bank announced its 2025 financial performance results at a Press Briefing following the 41st Annual General Meeting, highlighting a year of strong growth, resilience and strategic execution...
                </p>
                <a href="/indo-zambia-bank-announces-2025-financial-performance-results">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet" style={{ display: "none" }}>
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider38} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day" style={{ textTransform: "none" }}>
                    Indo Zambia Bank Highlights Strong Sector Support at Annual Delivery Day
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>April 09, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                  Indo Zambia Bank participated in the flagship Annual Delivery Day hosted by the Presidential Delivery Unit, showcasing significant progress across agriculture, energy, health and SME development...
                </p>
                <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-6 hide-on-tablet" style={{ display: "none" }}>
            <div
              className="single-blog-style1 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <a href="/mtn-momo-izb-partnership" style={{ textTransform: "none" }}>
                <div className="img-holder">
                  <div className="inner">
                    <img className="imgresize" src={izbNewsSlider35} alt="" />

                    <div className="overlay-icon"></div>

                  </div>
                </div>
              </a>
              <div className="text-holder">
                <h3 className="blog-title mt-0 text-left">
                  <a href="/mtn-momo-izb-partnership" style={{ textTransform: "none" }}>
                    𝗠𝗧𝗡 𝗠𝗼𝗯𝗶𝗹𝗲 𝗠𝗼𝗻𝗲𝘆 𝗭𝗮𝗺𝗯𝗶𝗮 𝗮𝗻𝗱 𝗜𝗻𝗱𝗼 𝗭𝗮𝗺𝗯𝗶𝗮 𝗕𝗮𝗻𝗸 𝗔𝗻𝗻𝗼𝘂𝗻𝗰𝗲 𝗦𝗲𝗮𝗺𝗹𝗲𝘀𝘀 𝗠𝗼𝗠𝗼 𝗣𝗮𝘆𝗺𝗲𝗻𝘁𝘀 𝗼𝗻 𝗔𝗹𝗹 𝗜𝗭𝗕 𝗣𝗢𝗦 𝗧𝗲𝗿𝗺𝗶𝗻𝗮𝗹𝘀
                  </a><br />
                  <span style={{ fontSize: "15px", color: "gray" }}>March 18, 2026</span>
                </h3>
                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                  MTN Mobile Money Zambia and Indo Zambia Bank (IZB) have announced a strategic partnership that enables MoMo MTN customers to make seamless payments across all IZB Point of Sale (POS) terminals nationwide...

                </p>
                <a href="/mtn-momo-izb-partnership">
                  <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                  </h5>
                </a>
                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
              </div>
            </div>
          </div>

          <div className="test show-on-tablet news-slider-list-slider row align-items-center">
            <Slider {...settings}>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="/indo-zambia-bank-announces-2025-financial-performance-results">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider37} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="/indo-zambia-bank-announces-2025-financial-performance-results">
                           Indo Zambia Bank Announces Strong 2025 Financial Performance Results
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>April 09, 2026</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                           Indo Zambia Bank announced its 2025 financial performance results at a Press Briefing following the 41st Annual General Meeting, highlighting strong growth...
                    </p>
                    <a href="/indo-zambia-bank-announces-2025-financial-performance-results">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider38} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day">
                          Indo Zambia Bank Highlights Strong Sector Support at Annual Delivery Day
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>April 09, 2026</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                           Indo Zambia Bank participated in the flagship Annual Delivery Day hosted by the Presidential Delivery Unit, showcasing significant progress across agriculture and energy...
                    </p>
                    <a href="/indo-zambia-bank-highlights-sector-support-annual-delivery-day">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

              <div className="">
                <div
                  className="single-blog-style1 wow fadeInUp"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                    <div className="img-holder">
                      <div className="inner">
                        <img className="imgresize" src={izbNewsSlider31} alt="" />
                        <div className="overlay-icon"></div>
                      </div>
                    </div>
                  </a>
                  <div className="text-holder">
                    <h3 className="blog-title mt-0 text-left">
                      <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                          Indo Zambia Bank proudly reaffirmed its commitment...
                      </a><br />
                      <span style={{ fontSize: "15px", color: "gray" }}>November 15, 2025</span>
                    </h3>
                    <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank is proud to have officially handed over a fully furbished and equipped state-of-the-art Theatre unit and Dental unit, valued at over ZMW 1 million, to The Ministry of Health at The Zambia Flying Doctors...
                    </p>
                    <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                      <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                        Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                      </h5>
                    </a>
                    <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                  </div>
                </div>
              </div>

            </Slider>
          </div>

        </div>
      </div>
    </section>
  );
};

export default NewsSlider;